import { useEffect } from "react";

/**
 * Holds the page still while an overlay is open.
 *
 * MUI's own scroll lock sets `overflow: hidden` on `body`, which does nothing
 * here: Lenis scrolls `documentElement`, so the page carries on sliding behind
 * the backdrop. `data-lenis-prevent` is not enough either, because it only tells
 * Lenis to leave the event alone and the browser then scrolls natively. Locking
 * the element that actually scrolls is what stops both.
 */
export function useLockPageScroll(locked: boolean) {
  useEffect(() => {
    if (!locked || typeof document === "undefined") return;
    const root = document.documentElement;
    const previousOverflow = root.style.overflow;
    const previousBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto";
    root.style.overflow = "hidden";
    return () => {
      root.style.overflow = previousOverflow;
      root.style.scrollBehavior = previousBehavior;
    };
  }, [locked]);
}

export default useLockPageScroll;
